export default "__VITE_ASSET__43PjZyS1__"